module.exports = __webpack_public_path__ + "img/dropbox.fbb21049.svg";